export default function CONCAT() {
  return <div>Excel_CONCAT</div>;
}
